import { Pipe, PipeTransform } from '@angular/core';

import { hasUserAccess } from 'src/app/user/constants/constants';

@Pipe({ name: 'hasUserAccess', standalone: true })
export class HasUserAccessPipe implements PipeTransform {
  transform(section: string, userData: any): boolean {
    return hasUserAccess(section, userData);
  }
}
